import { IMenuItem } from "@trussle/external-components";

export enum MENU_ITEM_CHILDREN {
  EMAIL_WIDGET = "email-widget"
}

export interface IMenuItemFromContentful extends IMenuItem {
  childrenType: string;
}
